module.exports = __webpack_public_path__ + "0f15a1e9b846767b70d18bea3d02fb66.svg";